import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { useAuth } from '@/src/hooks/useAuth'
import type { AppDispatch } from '@/src/store'
import { refetchCurrentUserAndSyncAuth } from '@/src/@core/utils/refetch-current-user-and-sync-auth'

const USER_MANAGEMENT_PATH_PREFIX = '/app/user-management'

/**
 * When the session user navigates away from User management, reload `/me` and sync `AuthContext`
 * so page-level ACL (e.g. kitchen-management) matches server permissions without a full browser refresh.
 */
export function AuthSessionRefreshOnUserManagementExit() {
  const router = useRouter()
  const dispatch = useDispatch<AppDispatch>()
  const auth = useAuth()
  const prevPathnameRef = useRef<string | null>(null)

  useEffect(() => {
    if (!router.isReady) {
      return
    }

    const prev = prevPathnameRef.current
    const curr = router.pathname

    const wasUnderUserManagement = prev !== null && prev.startsWith(USER_MANAGEMENT_PATH_PREFIX)
    const nowUnderUserManagement = curr.startsWith(USER_MANAGEMENT_PATH_PREFIX)

    if (auth.user && wasUnderUserManagement && !nowUnderUserManagement) {
      void refetchCurrentUserAndSyncAuth(dispatch, auth.setUser, auth.user.id)
    }

    prevPathnameRef.current = curr
  }, [router.isReady, router.pathname, auth.user, auth.setUser, dispatch])

  return null
}
